import React, { useEffect, useState } from "react";
import ProjectCards from "../../../../stories/components/ProjectCards/ProjectCards";
import {
  CardProps,
  toCardProps,
} from "../../../../stories/components/ProjectCards/Card";
import { WithLoad } from "utils/types";
import { getHotProjects } from "apiv1/recommend";
import shuffle from "lodash/shuffle";

const TopItemAttention: React.VFC = () => {
  const [projects, setProjects] = useState<WithLoad<CardProps[]>>("loading");
  useEffect(() => {
    getHotProjects()
      .then((res) => {
        const projects = shuffle(res.data.map(toCardProps));
        setProjects(projects);
      })
      .catch(() => setProjects("notfound"));
  }, []);

  return <ProjectCards title="注目作品" cards={projects} />;
};

export default TopItemAttention;
